import React from "react"
import { Box } from "@mui/material"

import { AppCardTitle, AppLegendChips } from "@components"
import { dsColorNew } from "@palette"

// What each icon in the Status column means; the short label keeps the strip on one line
const analyzers = [
	{ icon: "tally", short: "LOR", label: "LOR Analyzer" },
	{ icon: "calendar-days", short: "DOR", label: "DOR Analyzer", color: dsColorNew.appBlue },
	{ icon: "handshake", short: "Brokers", label: "Brokers Analyzer", color: dsColorNew.noteAmber },
	{ icon: "chart-line", short: "Direct Site", label: "Direct Site", color: dsColorNew.successText },
	{ icon: "star", short: "Rating", label: "Rating analyzer", color: dsColorNew.noteAmber },
]
const downloads = [
	{ icon: "cloud-arrow-down", short: "Multi-report", label: "Download multi-report", color: "colors.pink" },
	{ icon: "file-arrow-down", short: "Multi-export", label: "Download multi-export", color: "colors.deepPurple" },
]

export default function ReportListTableHomeCustomToolbar({ title }) {

	return <Box>
		<AppCardTitle icon="clock-rotate-left" title={title}/>

		<AppLegendChips aria-label="Icons in the Status column" groups={[analyzers, downloads]} sx={{ mt: 1.5 }}/>
	</Box>
}
